import HttpClient from './http-client';
import URL from './url';

export default class AuthenticateAPI {

    static login(payload) {
        return HttpClient.post(URL.BASE_URL + URL.LOGIN, null, payload);
    }

    static changePassword(payload) {
        return HttpClient.put(URL.BASE_URL + URL.CHANGE_PASSWORD, null, payload);
    }

    static createQuickSurvey(payload) {
        return HttpClient.post(URL.BASE_URL + URL.STAFF_QUICK_SURVEY, null, payload);
    }
}
